import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
//
import { updateStatusCategory } from "store/thunks";
import {
    CONFIG_OPTION_TOAST_ERROR,
    CONFIG_OPTION_TOAST_NORMAL,
} from "common/toast";

interface CheckboxStatusProps {
    item: {
        id: number;
        is_active: boolean;
        is_deleted?: number;
    };
    isDisabled?: boolean;
    onChange?: (id: number, active: boolean) => void;
}

const CheckboxStatus = ({ item, isDisabled, onChange }: CheckboxStatusProps) => {
    const { t } = useTranslation();
    const [isActive, setIsActive] = useState<boolean>(item.is_active);
    const handleOnConfirmUpdate = async (id: number, active: boolean) => {
        setIsActive(active);
        onChange && onChange(id, active);
        const response = await updateStatusCategory(id, { is_active: active });
        if (typeof response === "string") {
            setIsActive(item.is_active); // Rollback
            toast(response, CONFIG_OPTION_TOAST_ERROR);
            return;
        }

        if (response.statusCode !== 200) {
            setIsActive(item.is_active); // Rollback
            toast(response.message || "Error", CONFIG_OPTION_TOAST_ERROR);
            return;
        }
        toast(t("The process has been completed."), CONFIG_OPTION_TOAST_NORMAL);
    };

    // Sync local state when item changes
    useEffect(() => {
        setIsActive(!!item.is_active);
    }, [item.is_active]);


    return (
        <div className="form-check form-switch form-switch-sm text-center" dir="ltr">
            <input
                type="checkbox"
                className="form-check-input"
                name="is_active"
                checked={isActive}
                disabled={!!(isDisabled || item?.is_deleted)}
                onChange={(e) => handleOnConfirmUpdate(item.id, e.target.checked)}
            />
            {item?.is_deleted && (
                <div>
                    <small className="text-danger">{t("Deleted")}</small>
                </div>
            )}
        </div>
    );
};

export default CheckboxStatus;
